'use client'

import { SegmentError } from '../_error-boundaries/segment-error.client'

type DestinationErrorProps = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function DestinationError(props: DestinationErrorProps) {
  return <SegmentError boundary="destination" {...props} />
}
